"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ComponentWrapper = _interopRequireDefault(require("../../../ComponentWrapper"));

var _MenuSlider = require("../MenuSlider.style");

var MenuSliderFooter = function MenuSliderFooter(_ref) {
  var footerPrimaryNav = _ref.footerPrimaryNav,
      footerSecondaryNav = _ref.footerSecondaryNav,
      toggleNav = _ref.toggleNav;
  return /*#__PURE__*/_react.default.createElement(_MenuSlider.SliderFooter, null, /*#__PURE__*/_react.default.createElement(_ComponentWrapper.default, {
    columnWidth: [12]
  }, /*#__PURE__*/_react.default.createElement(_MenuSlider.SliderFooterNavWrap, null, /*#__PURE__*/_react.default.createElement(_MenuSlider.SliderFooterPrimaryNav, null, footerPrimaryNav && footerPrimaryNav.map(function (link) {
    return /*#__PURE__*/_react.default.createElement(_MenuSlider.SliderFooterNavItem, Object.assign({
      key: link.label,
      to: link.url,
      onClick: function onClick() {
        toggleNav();
      }
    }, link), link.label);
  })), /*#__PURE__*/_react.default.createElement(_MenuSlider.SliderFooterSecondaryNav, null, footerSecondaryNav && footerSecondaryNav.map(function (link) {
    return /*#__PURE__*/_react.default.createElement(_MenuSlider.SliderFooterNavItem, Object.assign({
      key: link.label,
      to: link.url,
      onClick: function onClick() {
        toggleNav();
      }
    }, link), link.label);
  })))));
};

MenuSliderFooter.propTypes = {
  footerPrimaryNav: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  footerSecondaryNav: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  toggleNav: _propTypes.default.func.isRequired
};
MenuSliderFooter.defaultProps = {
  footerPrimaryNav: [],
  footerSecondaryNav: []
};
var _default = MenuSliderFooter;
exports.default = _default;